export const AiTaggingCheckService = Symbol.for('AiTaggingCheckService');
